<div *ngIf="visible" class="context-menu" [ngStyle]="{ background: menuColor }" [style.top.px]="y" [style.left.px]="x">
  <button *ngFor="let option of options" (click)="option.action(); close()">
    <div class="context-menu-option">
      <mat-icon class="context-menu-option-icon">{{ option.icon }}</mat-icon>
      {{ option.label }}
    </div>
  </button>
</div>
